import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ab6ccf8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Tournaments", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-left" }, [
  /*#__PURE__*/_createTextVNode("TRENDING "),
  /*#__PURE__*/_createElementVNode("span", { class: "live-text" }, [
    /*#__PURE__*/_createTextVNode("LIVE"),
    /*#__PURE__*/_createElementVNode("div", { class: "wave" })
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-left" }, "PAST TOURNAMENTS", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_loading_card = _resolveComponent("loading-card")!
  const _component_tournament_card = _resolveComponent("tournament-card")!
  const _component_ended_tournament_card = _resolveComponent("ended-tournament-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_loading_card, {
        loading: _ctx.loading,
        itemsLength: _ctx.trendingTournaments.length
      }, null, 8, ["loading", "itemsLength"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trendingTournaments, (tournament) => {
        return (_openBlock(), _createBlock(_component_v_row, {
          key: tournament.id
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { "my-2": "" }, {
              default: _withCtx(() => [
                _createVNode(_component_tournament_card, { tournament: tournament }, null, 8, ["tournament"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { class: "mt-4" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_loading_card, {
        loading: _ctx.loading,
        itemsLength: _ctx.endedTournaments.length
      }, {
        description: _withCtx(() => [
          _createTextVNode("No tournaments at the moment...")
        ]),
        _: 1
      }, 8, ["loading", "itemsLength"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.endedTournaments, (tournament) => {
        return (_openBlock(), _createBlock(_component_v_row, {
          key: tournament.id
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { "my-2": "" }, {
              default: _withCtx(() => [
                _createVNode(_component_ended_tournament_card, { tournament: tournament }, null, 8, ["tournament"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}